
import { axios, BaseApiUrl} from '../axios_config';

//查询基础数据
export const getStockIODataBasis = params => {
    return axios.get(`${BaseApiUrl}/Miscellaneous/GetStockIODataBasis`, { params: params });
};


//查询其他出入库报表
export const getStockIODataListAsync = params => {
    return axios.post(`${BaseApiUrl}/Miscellaneous/GetStockIODataListAsync`, params);
};
//导出其他出入库数据
export const exportStockIODataAsyncOut = `${BaseApiUrl}/Miscellaneous/StockIODataAsyncOut`;

//查询单据明细
export const getStockIODataItemByStockIODataID = params => {
    return axios.get(`${BaseApiUrl}/Miscellaneous/GetStockIODataItemByStockIODataID`, { params: params });
};

//预览装车图片
export const getStockIODataReviewImages = params => {
    return axios.get(`${BaseApiUrl}/Miscellaneous/GetStockIODataReviewImages`, { params: params });
};

//下载装车图片
export const getStockIODataReviewImagesFileOut = `${BaseApiUrl}/Miscellaneous/GetStockIODataReviewImagesFileOut`;

//重新同步
export const resynchronizeStockIOData = params => {
    return axios.get(`${BaseApiUrl}/Miscellaneous/ResynchronizeStockIOData`, { params: params });
};
